import { getAssetPath } from '@/constants/configs';
import {
  defaultConfigs,
  getExtraBasicInfoQuestions as defaultGetExtraBasicInfoQuestions,
  resolveICBWebUrl,
} from '@/constants/tenant-configs/default';

import { QuestionCode } from '@/types/api/pep';
import { AppConfigurations } from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { User } from '@/types/user';

import { isBusinessPurposeQuestionEnabled, isMinorUser } from '@/utils/user';

export const sintMaartenConfigs: AppConfigurations = {
  ...defaultConfigs,
  links: {
    ...defaultConfigs.links,
    privacyPolicyURL:
      'https://www.republicbankstmaarten.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://republiconline.republictt.com/sx/legal.html',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-sxm.pdf'),
    appTermsAndConditionsURL: getAssetPath('/tnc/republiconboard-tnc-sxm.pdf'),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-sxm.pdf',
    ),
    icbWeb: resolveICBWebUrl(
      'https://republiconlinesx.rfhl.com/RBSX.UI/#/administrationGeneral/login',
    ),
    icbIOS: 'https://apps.apple.com/us/app/republicmobile-sx/id1615103714',
    icbAndroid:
      'https://play.google.com/store/apps/details?id=sxicprod.com.republicapp&pli=1',
    eFreeURL: 'https://www.republicbankstmaarten.com/personal/e-free-account',
    eFreeUsdURL:
      'https://www.republicbankstmaarten.com/personal/e-free-usd-account',
    savingsPlusURL:
      'https://www.republicbankstmaarten.com/personal/savings-plus-account',
  },
  defaultCountryCode: '1721',
  locale: 'en-SXM',
  isoCode: 'SXM',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'ANG',
  idCaptureRequirement: 'idCardOrPassport',
  idDocumentTypes: [
    DocumentType.Id,
    DocumentType.Passport,
    DocumentType.IdentityDriverLicense,
  ],
  showSelfEmployedStartupQuestion: true,
  showRiskSectorFlagQuestion: false,
  showSelfEmployedWithRiskSectorFlagQuestion: true,
  shouldRejectNonResidentMinor: true,
  existingCustomer: {
    maxAccountsPerType: 2,
  },
  jointAccountRelationshipOptions: [
    { value: 'PARENT', i18nKey: 'minorOthers.form.relationship.parent' },
    {
      value: 'LEGAL_GUARDIAN',
      i18nKey: 'minorOthers.form.relationship.legalGuardian',
    },
  ],
};

export const getExtraBasicInfoQuestions = (user: User) => {
  if (isMinorUser(user)) {
    return defaultGetExtraBasicInfoQuestions(user);
  }
  return {
    ...defaultGetExtraBasicInfoQuestions(user),
    [QuestionCode.AccountPurpose]: {
      enabled: isBusinessPurposeQuestionEnabled(user),
      question: 'questionDrawer.accountPurpose.question',
      priority: 0,
    },
    [QuestionCode.GrossMonthlyIncome]: {
      enabled: user.monthlyIncome === undefined,
      question: 'questionDrawer.expectedGrossMonthlyIncome',
      priority: 7,
    },
    [QuestionCode.FundingSource]: {
      enabled: user.fundingSource === undefined,
      question: 'questionDrawer.sourceOfFunding',
      priority: 8,
    },
  };
};
